<template>

    <div class="image-cta">
        <MoonSpinner
            v-if="loading"
            :loading="true"
            container-size="160px"/>

        <div v-else class="d-flex flex-column md-d-block">

            <template v-if="selected">
                <div class="d-flex image-cta__content">

                    <div class="--tablet-up w-60 position-relative sizing-container br-default o-hidden">
                        <img :src="sizingImg" alt="" class="sizing-placeholder">
                        <transition name="fadeSlow">
                            <img :src="selected.image.url" :key="selected.image.src" :alt="selected.image.alt" class="img-bg-cover">
                        </transition>
                    </div>

                    <div class="w-40 md-w-100 pl-3 md-pl-0 md-mb-3 sm-mb-2">
                        <div class="wysiwyg-content --uniform mb-3 md-text-center" v-html="data.content"></div>
                        <div v-for="(item,index) in items" id="links-container">
                            <div
                                class="defer p-2 d-flex align-items-center justify-content-between w-100 bg-semi-light-grey br-6 no-decoration fs-20 sm-fs-16 c-pointer"
                                :class="index === (items.length - 1) ? '' : 'my-2'"
                                :style="{color: (activeIndex === index) ? '#ffffff' : '#3C3C3B',
                                         backgroundColor: (activeIndex === index) ? color : '#D1D1D1'}"
                                @click="activeIndex = index">
                                <div>
                                    <span :style="{fontWeight: (activeIndex === index) ? 600 : 300}">{{ item.title }}</span> <span v-if="item.subtitle" class="fw-light">{{ item.subtitle }}</span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="--tablet-down w-100 position-relative sizing-container br-default o-hidden">
                        <img :src="sizingImg" alt="" class="sizing-placeholder">
                        <transition name="fadeSlow">
                            <img :src="selected.image.url" :key="selected.image.src" :alt="selected.image.alt" class="img-bg-cover">
                        </transition>
                    </div>

                </div>

                <div class="d-flex image-cta__cta" v-if="items[activeIndex].link">
                    <a
                        :href="items[activeIndex].link"
                        class="defer p-2 d-flex align-items-center bg-semi-light-grey br-6 no-decoration fs-20 sm-fs-16 mt-6 mr-0 ml-auto"
                        :style="{backgroundColor: color}"
                    >
                        <span :style="{ color: '#ffffff' }" class="fw-bold my-auto mr-2">Read more about the {{ items[activeIndex].title }}</span>
                        <icon-component
                            :width="12"
                            :height="20"
                            icon="arrow-right"
                            class="ml-auto mr-0 my-auto"
                            :color="'#ffffff'"
                        ></icon-component>

                    </a>
                </div>

            </template>

        </div>

    </div>

</template>

<script>

    import axios from 'axios';

    import MoonSpinner from "@/components/spinners/MoonSpinner";
    import IconComponent from "@/components/partials/IconComponent";


    export default {
        name: 'ImageCtaList',
        components: {MoonSpinner,IconComponent},

        props: {
            postId: {
                type: String,
                required: true
            },
            color: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                loading: true,
                data: null,

                activeIndex: 0,
                iconColor: '#3C3C3B',
            }
        },

        computed: {
            base() {
                return window.imgUrl;
            },
            sizingImg() {
                return this.base + '/svg/44-19-sizing.svg';
            },
            items() {
                return this.data
                    ? this.data.items : [];
            },
            selected() {
                if (!this.items.length) return null;
                return this.items[this.activeIndex];
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData() {

                axios
                    .get(`/api/post/${this.postId}/page-content/image-cta-list`)
                    .then(({ data }) => {
                        this.data = data;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                    });

            }
        }
    }

</script>
